import { getAsync as _getAsync, patchAsync as _patchAsync } from "../../api";

const BASE_URL = "/notifications";

export async function fildAllBySessionId() {
    return _getAsync({ url: `${BASE_URL}/mine` });
}

export async function markAsRead(ids) {
    return _patchAsync({ url: `${BASE_URL}/read`, data: { ids } });
}

export async function markAllAsReadBySessionId() {
    return _patchAsync({ url: `${BASE_URL}/read-all` });
}
